import { FC } from 'react';

import AiQuotaExceededModalHeader from './components/AiQuotaExceededModalHeader';
import AiQuotaExceededModalBody from './components/AiQuotaExceededModalBody';
import AiQuotaExceededModalFooter from './components/AiQuotaExceededModalFooter';

const AiQuotaExceededModal: FC = () => (
  <>
    <AiQuotaExceededModalHeader />
    <AiQuotaExceededModalBody />
    <AiQuotaExceededModalFooter />
  </>
);

export default AiQuotaExceededModal;
